<template>
  <div id="NavigationV2" class="position-relative" :class="{ 'limit-scroll': remindersExtended || bookingsExtended }">
    <div id="newNavTop" class="newNavTop" :class="{ sideNavExpanded: sideNavExpanded }" ref="newTopNav">
      <div class="topNavLeftSide" :class="{ sideNavExpanded: sideNavExpanded }">
        <div v-if="sideNavExpanded" class="imgHolder">
          <img ref="navLogo"
            @click="$store.getters.user.user_client_id !== 3519 ? $router.push('/') : $router.push('/personal/my-company')"
            class="nav-logo clickable" :src="getLogo" alt="company logo" @error="imageErrorHandler" />
        </div>
        <div class="topButton" @click="toggleSideNav">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>
      </div>
      <div class="topNavMain text-white" :class="{ sideNavExpanded: sideNavExpanded }">
        <SearchBar class="searchBar" :placeholder="nav_elements.what_are_you_looking_for" />
        <div class="navItems" ref="navItem">
          <div class="topNavItem" v-for="(item, i) in topNav" :key="'nav-item-1-' + i" @click="navigate(item)">
            {{ item.label }}
            <div class="navDropDown bg-brand-primary" v-if="item.sub_items">
              <div class="navDropDownItem" v-for="sub in item.sub_items" @click="navigate(sub)">{{ sub.label }}</div>
            </div>
          </div>
        </div>
        <div class="iconRow">
          <i @click="home" :class="iconHoveredOver === 4 ? 'fa-solid' : 'fa-light'" class="fa-home navIcon"
            @mouseover="iconHoveredOver = 4" @mouseleave="iconHoveredOver = -1"></i>

          <!--          <i class="fa-solid fa-trophy navIcon" @click="toggleChallenges" :class="{challengesOpen: showChallenges}" @mouseover="iconHoveredOver = 5" @mouseleave="iconHoveredOver = -1"></i>-->
          <div class="navIcon apptNavIcon" :class="bookingsExtended ? 'extended' : null">
            <i @click="toggleBookingsExtended"
              :class="iconHoveredOver === 2 || bookingsExtended ? 'fa-solid' : 'fa-light'"
              class="fa-calendar-check navIcon" @mouseover="iconHoveredOver = 2" @mouseleave="iconHoveredOver = -1"></i>
            <div class="bookingAlert" v-if="showReminderAlert > 0"></div>
            <div v-if="showReminderAlert > 0" class="bookingAlertBox">
              <div class="bookingAlertBoxOuter" @mouseover="iconHoveredOver = 6" @mouseleave="iconHoveredOver = -1">
                <div class="bookingAlertBoxTriangle"></div>
                <div class="bookingAlertBoxInner">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  {{ showReminderAlert > 1 ? 'You have bookings today, click here to view details' : 'You have a booking
                  today, click here to view details' }}
                </div>
              </div>
            </div>
            <div class="iconDropDown apptHolder">
              <!--              <NavAppointmentHolder :bookings="bookings" @reload="getBookings" @close="bookingsExtended = false"/>-->
            </div>
          </div>
          <div class="navIcon reminderNavIcon" :class="remindersExtended ? 'extended' : null">
            <i @click="goToNotificationCentre"
              :class="iconHoveredOver === 3 || remindersExtended ? 'fa-solid' : 'fa-light'" class="fa-bell navIcon"
              @mouseover="iconHoveredOver = 3" @mouseleave="iconHoveredOver = -1"></i>
            <div class="bookingAlert" v-if="unseenNotifications"></div>
            <div v-if="unseenNotifications" class="bookingAlertBox">
              <div class="bookingAlertBoxOuter" @mouseover="iconHoveredOver = 3" @mouseleave="iconHoveredOver = -1"
                v-if="!remindersExtended">
                <div class="bookingAlertBoxTriangle"></div>
                <div class="bookingAlertBoxInner">
                  <i class="fa-solid fa-circle-exclamation"></i>
                  Click the bell icon to see notifications
                </div>
              </div>
            </div>
            <div class="iconDropDown reminderDropDown">
              <!--              <ReminderHolder :notifications="notifications" @close="remindersExtended = false"/>-->
            </div>
          </div>
        </div>
        <DarkModeToggler :nav_elements="nav_elements" />
      </div>
    </div>
    <div class="newNavSide" :class="{ sideNavExpanded: sideNavExpanded }">
      <div class="sideNavItemsTop">
        <div class="sideNavItem" @click="home">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-house topIcon"></i>
            <div>{{ nav_elements.home }}</div>
          </div>
        </div>
        <div v-for="(item, i) in nav" :key="'nav-item-2-' + i" @click="navigate(item)" class="hiddenSideNav"
          v-if="!adminMode">
          <div class="sideNavItem">
            <div class="sideNavItemInner" v-if="!item.sub_items" @click="navigate(item)">
              <i v-if="item.icon" class="topIcon fa-solid" :class="item.icon"></i>
              <div>{{ item.label }}</div>
            </div>
            <div class="sideNavItemInner" v-else @click="extendSideNav(i)">
              <i v-if="sideNavItemExtended === i" class=" topIcon fa-regular fa-chevron-up"></i>
              <i v-else class=" topIcon fa-regular fa-chevron-down"></i>
              <div>{{ item.label }}</div>
            </div>
            <div class="sideNavDropDown" v-if="item.sub_items" :class="sideNavItemExtended === i ? 'extended' : null">
              <div class="sideNavDropDownItem sideNavItem subDropDown" v-for="sub in item.sub_items"
                @click="navigate(sub)">
                <div class="sideNavItemInner pl-5">
                  <i v-if="sub.icon" class="fa-solid subIcon" :class="sub.icon"></i>
                  <div>{{ sub.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-for="(item, i) in sideNav" :key="'nav-item-3' + i" @click="navigate(item)" v-if="!adminMode">
          <div class="sideNavItem">
            <div class="sideNavItemInner" v-if="!item.sub_items" @click="navigate(item)">
              <i class="topIcon fa-solid" :class="item.icon ? item.icon : 'fa-circle'"></i>
              <div>{{ item.label }}</div>
            </div>
            <div class="sideNavItemInner" v-else @click="extendSideNav(i)">
              <i v-if="sideNavItemExtended === i" class=" topIcon fa-regular fa-chevron-up"></i>
              <i v-else class=" topIcon fa-regular fa-chevron-down"></i>
              <div>{{ item.label }}</div>
            </div>
            <div class="sideNavDropDown" v-if="item.sub_items" :class="sideNavItemExtended === i ? 'extended' : null">
              <div class="sideNavDropDownItem sideNavItem subDropDown" v-for="sub in item.sub_items"
                @click="navigate(sub)">
                <div class="sideNavItemInner pl-5">
                  <i class="fa-solid subIcon" :class="sub.icon ? sub.icon : 'fa-circle'"></i>
                  <div>{{ sub.label }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--        <div class="sideNavItem">-->
        <!--          <i class="fa-solid fa-chart-line"></i> My Progress-->
        <!--        </div>-->
        <!--        <div class="sideNavItem">-->
        <!--          <i class="fa-solid fa-list-ul"></i> My List-->
        <!--        </div>-->
        <!--        <div class="sideNavItem">-->
        <!--          <i class="fa-solid fa-clapperboard"></i>New Releases-->
        <!--        </div>-->
      </div>

      <!--      Start of admin section-->
      <div class="sideNavItemsBottom" v-if="adminMode">

        <div class="sideNavItem" @click="navigateFromFixedButton('/customise')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-table-cells-large topIcon"></i>
            <div>{{ admin_elements.branding_customise }}</div>
          </div>
        </div>

        <div class="sideNavItem" @click="navigateFromFixedButton('/custom-content')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-clapperboard topIcon"></i>
            <div>{{ admin_elements.custom_content }}</div>
          </div>
        </div>

        <div class="sideNavItem" @click="navigateFromFixedButton('/data-analytics')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-chart-area topIcon"></i>
            <div>{{ admin_elements.data_analytics }}</div>
          </div>
        </div>

        <div class="sideNavItem" @click="navigateFromFixedButton('/user-management')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-user topIcon"></i>
            <div>{{ admin_elements.user_management }}</div>
          </div>
        </div>
      </div>
      <!--      End of admin section -->

      <div class="sideNavItemsBottom" v-if="!adminMode">
        <div class="sideNavItem" @click="navigateFromFixedButton('/my-progress')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-chart-line topIcon"></i>
            <div>{{ nav_elements.my_progress }}</div>
          </div>
        </div>
        <div class="sideNavItem" @click="navigateFromFixedButton('/my-list')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-list-ul topIcon"></i>
            <div>{{ nav_elements.my_list }}</div>
          </div>
        </div>
        <div class="sideNavItem" @click="navigateFromFixedButton('/favourites')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-star topIcon"></i>
            <div>{{ nav_elements.favourites }}</div>
          </div>
        </div>
        <div class="sideNavItem profileNavItem">
          <div class="sideNavItemInner" @click="navigateFromFixedButton('/settings')">
            <i class="fa-solid fa-user topIcon"></i>
            <div>{{ nav_elements.profile }}</div>
          </div>
        </div>
        <div class="sideNavItem" @click="logOut">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-right-from-bracket topIcon"></i>
            <div>{{ nav_elements.logout }}</div>
          </div>
        </div>
        <div class="sideNavItem faqNavItem" @click="navigateFromFixedButton('/faqs')">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-circle-info topIcon"></i>
            <div>Help</div>
          </div>
        </div>
        <div class="sideNavItem" @click="openEmployerOSDirect" v-if="showEmployerOSEntry">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-arrow-up-right-from-square topIcon"></i>
            <div>Enter Employer OS</div>
          </div>
        </div>
        <div class="sideNavItem" @click="adminMode = !adminMode" v-else-if="showAdminToggle">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-gear topIcon"></i>
            <div>{{ admin_btn_text }}</div>
          </div>
        </div>
        <!--        <div class="col-12 locations sideNavItem" v-if="showThemes">-->
        <!--          <div class="mt-5">Choose theme (dev only)</div>-->
        <!--          <b-form-select v-model="selectedSkin" class="select-location" style="font-family: Open Sans, sans-serif;font-size: 14px">-->
        <!--            <option :value="0">0 / base</option>-->
        <!--            <option :value="1">1 / blue</option>-->
        <!--            <option :value="2">2 / green</option>-->
        <!--            <option :value="3">3 / gold</option>-->
        <!--            <option :value="4">4 / red</option>-->
        <!--            <option :value="5">5 / grey</option>-->
        <!--            <option :value="6">6 / purple</option>-->
        <!--            <option :value="7">7 / Vodafone</option>-->
        <!--            <option :value="8">8 / BOI</option>-->
        <!--            <option :value="9">9 / DAA</option>-->
        <!--            <option :value="10">10 / Laya EAP</option>-->
        <!--            <option :value="11">11 / Incorporate Benefits</option>-->
        <!--            <option :value="12">12 / Run in the dark</option>-->
        <!--            <option :value="13">13 / SanusX</option>-->
        <!--            <option :value="14">14 / Microsoft</option>-->
        <!--            <option :value="15">15 / L&W</option>-->
        <!--            <option :value="16">16 / BOI no logos</option>-->
        <!--            <option :value="17">17 / Ornua</option>-->
        <!--            <option :value="18">18 / Simply Health</option>-->
        <!--            <option :value="19">19 / PWC</option>-->
        <!--            <option :value="20">20 / Benedend Health</option>-->
        <!--            <option :value="21">21 / Irish Distillers</option>-->
        <!--            <option :value="22">22 / Pfizer</option>-->
        <!--            <option :value="23">23 / Radox</option>-->
        <!--            <option :value="24">24 / EY</option>-->
        <!--            <option :value="25">25 / L&G</option>-->
        <!--            <option :value="26">26 / WAP</option>-->
        <!--            <option :value="27">27 / HCML</option>-->
        <!--            <option :value="28">28 / EY</option>-->
        <!--            <option :value="29">29 / Bupa</option>-->
        <!--            <option :value="30">30 / Hospitality Action</option>-->
        <!--            <option :value="32">32 / Intel</option>-->
        <!--            <option :value="35">35 / Grocery Aid</option>-->
        <!--          </b-form-select>-->
        <!--        </div>-->
        <!--        <LanguageSelector class="sideNavItem" :title="nav_elements.choose_language"/>-->
      </div>

      <div class="sideNavItemsBottom" v-if="adminMode">
        <div class="sideNavItem" @click="logOut">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-right-from-bracket topIcon"></i>
            <div>{{ nav_elements.logout }}</div>
          </div>
        </div>
        <div class="sideNavItem" @click="adminMode = !adminMode" v-if="showAdminToggle">
          <div class="sideNavItemInner">
            <i class="fa-solid fa-gear topIcon"></i> {{ admin_btn_text }}
          </div>
        </div>
        <!--        <LanguageSelector class="sideNavItem" :title="nav_elements.choose_language"/>-->
      </div>


      <!--      <div class="adminBoxHolder">-->
      <!--        <div class="adminBox">-->

      <!--        </div>-->
      <!--      </div>-->
    </div>
    <div class="newNavContent" :class="{ 'limit-scroll': remindersExtended || bookingsExtended }">
      <div class="w-100 h-100 position-relative">
        <SideBar v-show="bookingsExtended || remindersExtended" :appointments="bookings" :reminders="notifications"
          :show-appointments="bookingsExtended" :show-reminders="remindersExtended" />
        <slot></slot>
        <!--          <Challenges :top-nav-height="topNavHeight" :show-challenges="showChallenges" @closeChallenges="closeChallenges"/>-->
      </div>
    </div>
  </div>
</template>
<script>

import SearchBar from "@/components/SearchBar.vue";
import { mapGetters } from "vuex";
import NavAppointmentHolder from "@/components/NavAppointmentHolder.vue";
import EventBus from "@/helpers/eventbus";
import moment from "moment";
import LanguageSelector from "@/components/Wellbeing/LanguageSelector.vue";
import Challenges from "@/components/Challenges/Challenges.vue";
import DarkModeToggler from "@/components/Home/New/DarkModeToggler.vue";
import ReminderHolder from "@/components/ReminderHolder.vue";
import SideBar from "@/components/SideBar.vue";
import axios from "axios";
import config from "@/config/constants";

export default {
  name: "NavigationV2",
  components: {
    ReminderHolder,
    SearchBar,
    NavAppointmentHolder,
    Challenges,
    LanguageSelector,
    DarkModeToggler,
    SideBar
  },
  data() {
    return {
      selectedSkin: this.$store.getters.skin,
      sideNavExpanded: false,
      iconHoveredOver: -1,
      bookings: [],
      notifications: [],
      sideNavItemExtended: -1,
      bookingsExtended: false,
      remindersExtended: false,
      showChallenges: false,
      topNavHeight: 77,
      adminMode: false,
      unseenNotifications: false,
      testNotifications: [
        {
          id: 1,
          read_at: null,
          created_at: "2023-09-01 12:21:37",
          subject: "Your initial appointment is starting in 5 minutes",
          body: "Your initial appointment with Roman Coach is starting in 5 minutes",
          data: {
            "actionUrl": {
              href: "/total-mental-health"
            }
          }
        },
        {
          id: 0,
          read_at: "2023-09-01 12:53:37",
          created_at: "2023-09-01 12:53:37",
          subject: "Your initial appointment is starting in 30 minutes",
          body: "Your initial appointment with Roman Coach is starting in 30 minutes",
          data: {
            "actionUrl": {
              href: "/total-mental-health"
            }
          }
        },
      ],
      defaultLightLogo: '/img/spectrum_life_logo_light.png',
      defaultDarkLogo: '/img/spectrum_life_logo_dark.png',
      errorWithLogo: false,
      unreadInterval: null
    }
  },
  methods: {
    async buildHandoffUrl() {
      const handoffToken = await this.$store.dispatch("requestNepHandoffToken");
      if (!handoffToken) return null;
      const returnUrl = window.location.href;
      const host = config.employer_os_host || '';
      return `${host}/#token=${encodeURIComponent(handoffToken)}&returnUrl=${encodeURIComponent(returnUrl)}&mode=standalone`;
    },
    async openEmployerOSDirect() {
      const url = await this.buildHandoffUrl();
      if (!url) {
        this.$store.commit("setWarning", "Unable to open Employer OS right now. Please try again.");
        return;
      }
      window.location.href = url;
    },
    submitSamlResponse(samlResponse, acsUrl) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = acsUrl;

      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'SAMLResponse';
      input.value = samlResponse;

      form.appendChild(input);
      document.body.appendChild(form);
      form.submit();
    },
    async getBenefitsUrl() {
      if (this.$store.getters.skin === 25 && this.$store.getters.user.access_code_user) {
        window.location.href = 'https://spectrumbenefits.benefithub.com/';
      } else {
        const slPayload = {
          user_id: this.$store.getters.user_id,
        };
        let slRes = await axios.post(
          config.api_env + "/application/api/p/saml/sso",
          slPayload,
          config.options
        );
        this.submitSamlResponse(slRes.data.samlResponse, slRes.data.acsUrl);
      }
    },
    imageErrorHandler(e) {
      this.errorWithLogo = true;
      e.target.src = this.darkMode ? this.defaultDarkLogo : this.defaultLightLogo;
    },
    // TODO: remove if notification sidebar is not needed
    // toggleRemindersExtended() {
    //   this.updateNavHeight();
    //   this.bookingsExtended = false;
    //   this.remindersExtended = !this.remindersExtended;
    //   if(this.remindersExtended) {
    //     EventBus.$emit('getReminders');
    //     this.unseenNotifications = false;
    //   }
    // },
    goToNotificationCentre() {
      this.$router.push('/notification-centre');
    },
    async checkForNotifications() {
      const res = await this.api({
        path: 'api/u/notifications/unread'
      })
      if (res.success) {
        this.unseenNotifications = res.unread_count && res.unread_count > 0;
      } else {
        this.unseenNotifications = false;
      }
    },
    closeChallenges() {
      this.showChallenges = false;
    },
    toggleChallenges() {
      this.updateNavHeight();
      this.showChallenges = !this.showChallenges;
    },
    navigateFromFixedButton(url) {
      if (url === '/faqs') {
        window.open('/faqs', '_blank');
      } else {
        this.sideNavExpanded = false;
        this.$router.push(url)
      }

    },
    toggleSideNav() {
      EventBus.$emit("sideNavExpanded", !this.sideNavExpanded);
      this.sideNavExpanded = !this.sideNavExpanded;
    },
    toggleBookingsExtended() {
      this.updateNavHeight();
      if (this.showReminderAlert) this.$store.dispatch("setBookingReminderLastSeen");
      this.remindersExtended = false;
      this.bookingsExtended = !this.bookingsExtended;
    },
    extendSideNav(i) {
      if (i === this.sideNavItemExtended) {
        this.sideNavItemExtended = -1;
      } else {
        this.sideNavItemExtended = i;
      }
    },
    async getBookings() {
      try {
        let res = await this.api({
          path: "api/u/home-page/get-booking-widget",
        });
        if (res.success) {
          this.bookings = res.bookings;
          EventBus.$emit("setBookingReminders", this.bookings);

        }
        this.bookingsLoading = false;
      } catch (e) {
        this.bookingsLoading = false;
      }

    },
    logOut() {
      this.$store.dispatch("logout");
      this.$router.push("/login").catch(err => { });
    },
    home() {
      this.$router.push({ name: "home" });
      this.sideNavExpanded = false;
    },
    navigate(item) {
      if (item.hasOwnProperty("sub_items")) return;
      if (item.item_slug === 'rewards' && this.skin === 30) {
        this.getBenefitsUrl();
        return;
      }
      this.sideNavExpanded = false;
      if (!item.external_link) {
        if (item.asset_id) {
          this.$router.push({ name: item.item_slug, params: { id: item.asset_id } });
        } else {
          this.$router.push({ name: item.item_slug });
        }
      } else {

        // The if statement below determines if the link is a relative link (i.e. if it starts with '/')
        // or an external link.  With internal links, it will function as a normal internal link with the
        // url provided, otherwise the external link will be opened in a new page

        if (item.external_link.substring(0, 1) === "/") {
          this.$router.push(item.external_link);
          return;
        }
        window.open("https://" + item.external_link, "_blank");
      }
    },
    toggleDarkMode() {
      this.$store.dispatch("setDarkMode", !this.darkMode)
    },
    updateNavHeight() {
      this.topNavHeight = this.$refs.newTopNav.clientHeight;
    }
  },
  mounted() {
    this.getBookings();
    this.checkForNotifications();
    const _t = this;
    EventBus.$on('updateDFDReminders', function () {
      setTimeout(() => { _t.getBookings(); }, 2000);
    });
    EventBus.$on('closeSidebar', () => {
      this.bookingsExtended = false;
      this.remindersExtended = false;
    })
    window.addEventListener('resize', this.updateNavHeight);
    this.updateNavHeight();
    this.$store.dispatch('setMyList');
    if (this.$route.name === 'challenges') {
      this.showChallenges = true
    }
    this.unreadInterval = setInterval(() => {
      if (!this.unseenNotifications) this.checkForNotifications();
    }, 1000 * 60)
  },
  beforeDestroy() {
    if (this.unreadInterval) {
      clearInterval(this.unreadInterval);
    }
  },
  destroyed() {
    window.removeEventListener('resize', this.updateNavHeight);
  },
  watch: {
    selectedSkin(newVal) {
      this.$store.commit("setSkin", newVal);
    },
    darkMode(val) {
      if (this.errorWithLogo) {
        this.$refs.navLogo.src = val ? this.defaultDarkLogo : this.defaultLightLogo;
      }
    },
    iconHoveredOver(val) {
      if (val !== 2 && val !== -1) this.bookingsExtended = false
    }
  },
  computed: {
    ...mapGetters(["hardcoded", "skin", "client", "nav", "darkMode", "sideNav", "bookingReminderLastSeen", "navElements", "default_nav_elements", "user", "admin_nav_elements"]),
    showThemes() {
      return this.env !== 'production';
    },
    env() {
      return process.env.NODE_ENV;
    },
    topNav() {
      return this.nav;
    },
    isAdmin() {
      return this.user.user.employer_admin;
    },
    showEmployerOSEntry() {
      return this.user.user.employer_admin && this.user.user.is_nep_enabled;
    },
    showAdminToggle() {
      return this.user.user.employer_admin && !this.user.user.is_nep_enabled;
    },
    nav_elements() {
      let els = this.default_nav_elements;
      Object.entries(this.navElements).forEach(el => {
        const [key, value] = el;
        if (els.hasOwnProperty(key)) {
          els[key] = value.replace('&#39;', "'");
        }
      });
      return els;
    },
    admin_btn_text() {
      return this.adminMode ? this.admin_elements.exit_admin_view : this.admin_elements.enter_admin_view;
    },
    admin_elements() {
      let els = this.admin_nav_elements;
      Object.entries(this.navElements).forEach(el => {
        const [key, value] = el;
        if (els.hasOwnProperty(key)) {
          els[key] = value.replace('&#39;', "'");
        }
      });
      return els;
    },
    showReminderAlert() {
      const today = moment().format("YYYY-MM-DD");
      if (today === this.bookingReminderLastSeen) return false;
      let show = 0;
      this.bookings.map(item => {
        if (moment(item.start).format("YYYY-MM-DD") === today) show++;
      });
      return show;
    },
    getLogo() {
      if (this.hardcoded && this.hardcoded.client_logo) {
        return this.hardcoded.client_logo;
      } else if (this.skin === 8) {
        return "/img/boi/boi-logo-alt.png";
      } else {
        if (this.client.client_logo === "https://healthcoach-media.com/res/images/esp/customise/spectrum-life-logo.png") {
          return this.darkMode ? this.defaultDarkLogo : this.defaultLightLogo;
        }
        return this.client.client_logo
      }
    },
  }
}
</script>
<style lang="less">
.limit-scroll {
  height: 100vh;
  max-height: 100vh;
  overflow: hidden;
}
</style>